/**
 * Où ouvrir le canal temps réel, pour une racine d'API donnée.
 *
 * socket.io ne lit pas le chemin d'une adresse comme un préfixe : il en fait
 * l'*espace* (namespace) à rejoindre, et cherche toujours le serveur sur
 * `/socket.io`, à la racine du domaine. Tant que l'API était servie à la racine
 * (`https://api.bul.mg`), les deux se confondaient. Servie sous un préfixe
 * (`https://api.bul.mg/bul-api`, en octobre 2026), le client demandait l'espace
 * `/bul-api/realtime` à `https://api.bul.mg/socket.io`, qui répond 404 : le
 * canal ne s'ouvrait jamais, et l'application se croyait hors ligne.
 *
 * Le préfixe passe donc dans `path`, et l'espace reste `/realtime`.
 */
export function realtimeEndpoint(apiUrl: string): { url: string; path: string } {
  const match = /^([a-z][a-z\d+.-]*:\/\/[^/?#]+)([^?#]*)/i.exec(apiUrl.trim());
  if (!match) {
    return { url: `${apiUrl.replace(/\/+$/, '')}/realtime`, path: '/socket.io' };
  }
  const [, origin, prefix] = match;
  return { url: `${origin}/realtime`, path: `${prefix.replace(/\/+$/, '')}/socket.io` };
}
